import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  SimpleGrid,
  Paper,
  ThemeIcon,
  Text,
  Group,
  Button,
  Title,
  createStyles,
  Card,
} from "@mantine/core";
import {
  IconCalendar,
  IconClipboardList,
  IconUsers,
  IconBriefcase,
  IconCurrencyDollar,
  IconTrendingUp,
  IconUserPlus,
  IconChartBar,
} from "@tabler/icons-react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import AdminDashboardTop from "./adminDashboard";

import EmployeeStatusCard from "./employeesStatus";
import AttendanceOverviewCard from "./attendanceOverview";
import ClockInOut from "./checkInOut";
import EmployeesList from "./employee";
import RecentActivitiesCard from "./recentActivity";
import DashboardTabs from "components/DashboardTabs";
import MemberListing from "./memberListing";
import NotificationsCard from "./noticationcard";
import { useGetUser } from "api/users/getUser";
import ResetPasswordModal from "features/user/components/UserProfile/ResetPasswordModal";
import { User } from "types";

const ResponsiveContainerAny =
  ResponsiveContainer as unknown as React.ComponentType<any>;
const useStyles = createStyles((theme) => ({
  root: {
    padding: theme.spacing.xl,
  },
  card: {
    height: 160,
    borderRadius: 8,
    boxShadow: "0 1px 0 rgba(0,0,0,0.04)",
  },
  iconCircle: {
    width: 44,
    height: 44,
    borderRadius: 44,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  smallText: {
    fontSize: 13,
    color: theme.colors.gray[6],
    marginTop: 6,
  },
  bigNumber: {
    fontSize: 20,
    fontWeight: 700,
    marginTop: 6,
  },
  deltaPositive: {
    color: theme.colors.teal[6],
    fontWeight: 700,
    marginLeft: 8,
    fontSize: 13,
  },
  deltaNegative: {
    color: theme.colors.red[6],
    fontWeight: 700,
    marginLeft: 8,
    fontSize: 13,
  },
  viewAll: {
    marginTop: 12,
    color: theme.colors.gray[6],
    cursor: "pointer",
    fontSize: 13,
  },
  rightCard: {
    height: "100%",
    borderRadius: 8,
    padding: theme.spacing.md,
    boxShadow: "0 1px 0 rgba(0,0,0,0.04)",
  },
}));

const cardsData = [
  {
    id: 1,
    title: "Attendance",
    value: "92/99",
    delta: "+2.1%",
    positive: true,
    icon: <IconCalendar size={18} />,
    color: "#f97316",
  },
  {
    id: 2,
    title: "Total Project's",
    value: "90/94",
    delta: "-2.1%",
    positive: false,
    icon: <IconBriefcase size={18} />,
    color: "#2563eb",
  },
  {
    id: 3,
    title: "Total Clients",
    value: "69/86",
    delta: "-11.2%",
    positive: false,
    icon: <IconUsers size={18} />,
    color: "#3b82f6",
  },
  {
    id: 4,
    title: "Total Tasks",
    value: "25/28",
    delta: "+11.2%",
    positive: true,
    icon: <IconClipboardList size={18} />,
    color: "#ec4899",
  },
  {
    id: 5,
    title: "Earnings",
    value: "$2144",
    delta: "+10.2%",
    positive: true,
    icon: <IconCurrencyDollar size={18} />,
    color: "#8b5cf6",
  },
  {
    id: 6,
    title: "Profit This Week",
    value: "$5,544",
    delta: "+2.1%",
    positive: true,
    icon: <IconTrendingUp size={18} />,
    color: "#ef4444",
  },
  {
    id: 7,
    title: "Job Applicants",
    value: "98",
    delta: "+2.1%",
    positive: true,
    icon: <IconUsers size={18} />,
    color: "#10b981",
  },
  {
    id: 8,
    title: "New Hire",
    value: "45/48",
    delta: "-11.2%",
    positive: false,
    icon: <IconUserPlus size={18} />,
    color: "#111827",
  },
];

const chartData = [
  { name: "UI/UX", value: 80 },
  { name: "Development", value: 110 },
  { name: "Management", value: 90 },
  { name: "HR", value: 20 },
  { name: "Testing", value: 60 },
  { name: "Marketing", value: 100 },
];

export default function AdminDashboardPanel() {
  const { classes } = useStyles();

  const { data, isLoading, error }: any = useGetUser();
  const [openResetPassword, setOpenResetPassword] = useState(false);

  const user = data as User;

  useEffect(() => {
    if (user?.requirePasswordChange) {
      setOpenResetPassword(true);
    } else {
      setOpenResetPassword(false);
    }
  }, [user]);

  return (
    <Grid>
      {/* <Grid.Col span={12}>
        <DashboardTabs />
      </Grid.Col> */}
      <Grid.Col span={12}>
        <AdminDashboardTop />
      </Grid.Col>
      <Grid.Col span={4} xl={4} md={6}>
        <EmployeeStatusCard />
      </Grid.Col>
      <Grid.Col span={4} xl={4} md={6}>
        <AttendanceOverviewCard />
      </Grid.Col>
      <Grid.Col span={4} xl={4} md={6}>
        <ClockInOut />
      </Grid.Col>
      <Grid.Col span={6} md={6}>
        {" "}
        <MemberListing />
      </Grid.Col>
      <Grid.Col span={6} md={12} xl={6}>
        {/* <RecentActivitiesCard /> */}
        <NotificationsCard />
      </Grid.Col>

      <ResetPasswordModal
        opened={openResetPassword}
        onClose={() => setOpenResetPassword(false)}
        user={user}
      />
    </Grid>
  );
}
